import { render } from "./ShineLoading.vue?vue&type=template&id=49a2664e"
import script from "./ShineLoading.vue?vue&type=script&lang=js"
export * from "./ShineLoading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__